import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import NProgress from 'nprogress'
import './styles.css'

export const NavigationLoader = () => {
  let location = useLocation()
  useEffect(() => {
    NProgress.start()
    setTimeout(() => {
      NProgress.done()
    }, 500)
  }, [location])
  return <div />
}

